import { Container, Button,Form, Alert, Modal, Table} from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "./ContentStyles";
import {Pageheight} from "../index";
import React, {useMemo, useState, useEffect } from 'react';
import { FaFilePdf, FaCheck, FaEuroSign, FaShare, FaEdit} from 'react-icons/fa';
import useBackend, {CallAPI, Loading, SpinnerX, Check, Header} from '../services/useBackend';
import {SplitoutLocalDateFromISO, getOptions} from '../services/misc';

export default function Projects() {

    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);

    const [registrationModalshow, setRegistrationModalshow] = useState(false);
    const [projectDetailsModalshow, setProjectDetailsModalshow] = useState(false);
    const [projectToEdit, setProjectToEdit] = useState({comment:''});

    const [priceDefaultValue, setPriceDefaultValue] = useState(0);


    
    
    const initRegistrationModal = () => { setPriceDefaultValue(0); return setRegistrationModalshow(!registrationModalshow); } 
    const initProjectDetailsModal = () => { return setProjectDetailsModalshow(!projectDetailsModalshow) } 
    
    const {loading:ProjectsLoading, data:Projects, Refresh} =  useBackend(process.env.PUBLIC_URL+'/backend/projects');

    async function UpdateClickHandler() {
        const ProductForm = document.getElementById('FrmProjectUpdate');
        const formData = new FormData(ProductForm);
        const formDataObj = Object.fromEntries(formData.entries());

        setSpinnerHidden(false);
        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI("/backend/timelog/"+projectToEdit.guid,"PATCH", JSON.stringify(formDataObj));

        if (resultVariant!="success") {
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);            
        } else {
            setProjectDetailsModalshow(false);
        }        
        setSpinnerHidden(true);
        Refresh();
        //e.target.reset() ;      
    }   
    
    async function RegistrationAdd() {
        const RegistrationForm = document.getElementById('FrmRegistration');
        const formData = new FormData(RegistrationForm);
        const formDataObj = Object.fromEntries(formData.entries());

        console.log(JSON.stringify(formDataObj));        
        setSpinnerHidden(false);
        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI("/backend/projects/"+projectToEdit.guid,"POST", JSON.stringify(formDataObj));

        if (resultVariant!="success") {
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);            

        } else {
            // setProjectDetailsModalshow(false);
            setResultVariant(resultVariant);   
            setResultText(resultText);
            setResultVisible(resultVisible);     
            setPriceDefaultValue(0);   
                                Refresh();
        RegistrationForm.reset() ;           
        }        
        setSpinnerHidden(true);
  
    }
    
    async function DetailsClickHandler(event)  {
        event.preventDefault();
        const ProjectGUID = event.currentTarget.getAttribute("projectguid")

        let ProjectItem = Projects.projects.find(TLI=>TLI.guid==ProjectGUID);
        setProjectToEdit(ProjectItem);
        console.log(JSON.stringify(projectToEdit));

        initProjectDetailsModal();
        Refresh();     
    }

    async function CloseClickHandler(event)  {
        event.preventDefault();
        Refresh();     
    }
    
    async function InvoiceClickHandler(event)  {
        event.preventDefault();
        Refresh();     
    }    

    async function setFrmPrice(event)  {
        event.preventDefault();
        let Product = Projects.products.find(P=>P.id==event.target.value);
        console.log(Product);
        setPriceDefaultValue(Product.price);

    }    
    
    if (!ProjectsLoading) {
        return (
            <ContentWrapper>
                <Container>
                <Sida style={{minHeight:Pageheight(400)}}>
                    <Header Title="Projects"> <Button variant="danger" onClick={() => alert("Not implemented, use Postman")}>+</Button></Header>
                    <StyckeCompact>
                        <Table responsive="sm"  className="gridtable_">
                            <thead>
                                <tr> <td>Contact</td> <td>Reference</td> <td>Project</td> <td>startDate</td> <td>closeDate</td> <td>Uninvoiced</td>   </tr>
                            </thead>
                            <tbody> 
                                {Projects.projects.map((item) => {
                                    return <tr key={item.id}> <td>{item.contact.name}</td> <td>{item.reference}</td> <td>{item.name}</td> <td>{SplitoutLocalDateFromISO(item.startDate)}</td> <td>{SplitoutLocalDateFromISO(item.closeDate)}</td>  <td>{item.amountUninvoiced}</td> <td><FaEdit projectguid={item.guid} onClick={DetailsClickHandler} /></td> </tr>
                                })}
                                <tr> <td></td> <td></td> <td></td> <td></td> <td><b>=</b></td> <td><b>{Projects.totalAmountUninvoiced}</b></td>   </tr>
                            </tbody>
                        </Table>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                    </StyckeCompact>

                    <Modal show={registrationModalshow} onHide={initRegistrationModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Registrera Tid/matrial</Modal.Title>                            
                        </Modal.Header>                            
                        <Modal.Body>

                                <div style={{width:"90%"}}>
                                    <Form id="FrmRegistration">
                                
                                        <Form.Group className="mb-3">

                                        <Form.Label>Product</Form.Label>
                                        <Form.Select name='ProductId' onChange={setFrmPrice}>
                                            <option value={0}>Select</option>
                                            {getOptions(Projects.products)}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>DoneDate</Form.Label>
                                            <Form.Control type="date" name="DoneDate" placeholder="utfört Datum" defaultValue={Date.now()} />
                                        </Form.Group>                                        

                                        <Form.Group className="mb-3">
                                            <Form.Label>Qty</Form.Label>
                                            <Form.Control type="text" name ="Qty" placeholder="Qty"  defaultValue={1}/>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Price</Form.Label>
                                            <Form.Control type="text" name ="Price" placeholder="Price"  defaultValue={0} value={priceDefaultValue}  />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Comment</Form.Label>
                                            <Form.Control type="text" name ="Comment" placeholder="Comment" />
                                        </Form.Group>                                
                                    </Form> 
                                </div>

                            <Form.Group className="mb-3"  hidden={spinnerHidden}>
                                <SpinnerX  />
                            </Form.Group>                      

                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                               

                        </Modal.Body>

                        <Modal.Footer>
                            <Button className="CloudButton" variant="primary" type="button" onClick={RegistrationAdd}>Spara</Button>
                            <Button variant="danger" onClick={initRegistrationModal}>Avbryt</Button>                            
                        </Modal.Footer>                            

                    </Modal>                    

                    <Modal show={projectDetailsModalshow} onHide={initProjectDetailsModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Uppdatera Tid/matrial</Modal.Title>                            
                        </Modal.Header>                            
                        <Modal.Body>
                                <div style={{width:"90%"}}>
                                    <Form id="FrmProjectUpdate">                                    

                                        <Form.Group className="mb-3">
                                            <Form.Label>Project</Form.Label>
                                            <Form.Control type="text" name ="name" placeholder="Name" defaultValue={projectToEdit.name}/>
                                        </Form.Group>                                        

                                        <Form.Group className="mb-3">
                                            <Form.Label>Reference</Form.Label>
                                            <Form.Control type="text" name ="reference" placeholder="Reference" defaultValue={projectToEdit.reference}/>
                                        </Form.Group>
                      
                                    </Form> 
                                </div>

                            <Form.Group className="mb-3"  hidden={spinnerHidden}>
                                <SpinnerX  />
                            </Form.Group>                     

                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                               

                        </Modal.Body>

                        <Modal.Footer>
                            <Button className="CloudButton" variant="primary" type="button" onClick={initRegistrationModal}>Reg</Button>            
                            <Button className="CloudButton" variant="primary" type="button" onClick={InvoiceClickHandler}>Invoice project</Button>                                            
                            <Button className="CloudButton" variant="primary" type="button" onClick={UpdateClickHandler}>Save</Button>            
                            <Button className="CloudButton" variant="primary" type="button" onClick={CloseClickHandler}>Close project</Button>                            
                            {/* <Button variant="danger" onClick={initProjectDetailsModal}>Cancel</Button>                             */}
                        </Modal.Footer>                            

                    </Modal>  

                </Sida>
                </Container>
            </ContentWrapper>    
        );        
    } else {
        return (<Loading />);        
    }
}